import { apiMethods } from "../controller/Request";
import { Config } from "../controller/Global";


export const UserGet = (id, params = {}) => {
  const URL = Config['api']['auth']['user']['get'] + id + '/';
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const UserList = (params = {}) => {
  const URL = Config['api']['auth']['user']['list'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const UserPost = (params = {}) => {
  const URL = Config['api']['auth']['user']['post'];
  return apiMethods.post(URL, JSON.stringify(params), true)
    .then(response => {
      return response
    })

};
export const UserUpdate = (id, params = {}) => {
  const URL = Config['api']['auth']['user']['patch'] + id + '/';
  return apiMethods.patch(URL, JSON.stringify(params), true)
    .then(response => {
      return response
    })
};


export const UserPDFList = (params = {}) => {
  const URL = Config['api']['pdf']['user']['list'];
  apiMethods.getPDF(URL, params, true)
};


// WEBPACK FOOTER //
// ./src/models/employee.jsx